
import { ReactNode } from "react";
import { createFastContext } from "../../../../../../contexts/createFastContext";
import { OPERATION_TYPE, VALIDATION_STATUS } from "../../../../../../util/varibles/constants";
import { TOperation } from "../../../../../../util/varibles/interface";

export interface IMainOp {
    name: string
    data: {
        operation: TOperation
        is_main?: boolean
        start: number
        finish: number
        type: OPERATION_TYPE
        status?: VALIDATION_STATUS                      // For plan page
        message?: string
    }
    vesselsFilter?: {
        [id: string]: {
            [id: string]: boolean
        }
    }
}

interface IState {
    mainOps: {
        [id: string]: IMainOp
    }
    count: number,
}

const { Provider, useStore: useSupportOperation, setStore: setSupportOperation, getStore: getSupportOperation } = createFastContext<IState>({
    mainOps: {},
    count: 1
});

const SupportOperationProvider = ({ children, ...props }: {
    children: ReactNode,
} & Partial<IState>) => {

    return <Provider props={props}>
        {children}
    </Provider>
}


export { getSupportOperation, setSupportOperation, SupportOperationProvider, useSupportOperation };
